let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bQOCT")).then(() => parcelRequire('1V9Sw'));